import * as React from "react";
import Modal from "react-modal";
import "./confirm-modal.less";
import { shallowEqual } from "react-redux";
import {
  closeConfirmModal,
  selectConfirmModal,
} from "states/global-value/global-value.slice";
import { useAppDispatch, useAppSelector } from "app.hook";
import { IconClose } from "themes/icons";
Modal.setAppElement("#root");
export function ConfirmModal() {
  const dispatch = useAppDispatch();
  const confirmModalRedux = useAppSelector(selectConfirmModal, shallowEqual);
  return (
    <Modal
      portalClassName={"ReactModalPortalConfirm"}
      closeTimeoutMS={300}
      isOpen={confirmModalRedux?.isModal}
      onRequestClose={()=>{
        dispatch(closeConfirmModal());
      }}
      className={`drop-shadow top-1/4 relative outline-none rounded-md xl:w-1/4 mx-auto sm:w-full`}
      overlayClassName="Overlay"
    >
      <div className={`Confirm-Modal rounded-md p-4`}>
        <div className="modal-react-header flex justify-between">
          {confirmModalRedux?.title && (
            <h2 className="text-left text-xl font-semibold ">
              {confirmModalRedux?.title}
            </h2>
          )}
          <button aria-hidden="true" onClick={() => {
              dispatch(closeConfirmModal())
            }}>
            <IconClose width={15}/>
          </button>
        </div>
        <div className="modal-react-content  py-2 mt-4">
          <p className="">{confirmModalRedux?.message}</p>
        </div>
        <div className="space-x-2 text-center pt-5 mx-auto py-2 modal-react-footer">
          {confirmModalRedux.onClose && (
             <button
                onClick={() => {
                  dispatch(closeConfirmModal())
                }}
                className="btn--default px-8 transition-primary  uppercase btn--secondary hover:btn--secondary"
              >
                Cancel
            </button>
          )}
        
          <button
            onClick={confirmModalRedux?.onYes}
            className="btn--default px-8 transition-primary uppercase btn--primary"
          >
            {confirmModalRedux?.okText??"Confirm"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
